import { CategoryOutlined as CategoryIcon } from '@mui/icons-material'
import cn from 'classnames'
import { useTranslations } from 'next-intl'
import { RefinementList, RefinementListProps } from 'react-instantsearch'
import { RefinementUiConfig } from '../types'
import { SearchRefinementAccordion } from './SearchRefinementAccordion'

type CustomRefinementListProps = RefinementUiConfig &
  RefinementListProps & {
    defaultExpanded?: boolean
  }

export function CustomRefinementList({
  label,
  icon,
  defaultExpanded = true,
  ...refinementListProps
}: CustomRefinementListProps) {
  const t = useTranslations('CustomRefinementList')
  return (
    <SearchRefinementAccordion
      icon={icon || <CategoryIcon className="text-[22px]" />}
      label={label || ''}
      defaultExpanded={defaultExpanded}
    >
      <RefinementList
        {...refinementListProps}
        translations={{
          showMoreButtonText: ({ isShowingMore }) =>
            isShowingMore ? t('show_less') : t('show_more'),
          submitButtonTitle: t('submit_button_title'),
          resetButtonTitle: t('reset_button_title'),
          noResultsText: t('no_results'),
          ...refinementListProps.translations,
        }}
        classNames={{
          root: '',
          list: cn('flex flex-col gap-0'),
          item: cn(
            'list-none',
            'hover:[&_.ais-RefinementList-labelText]:text-mydra-purple'
          ),
          selectedItem: cn(
            '[&_.ais-RefinementList-labelText]:text-mydra-purple',
            '[&_.ais-RefinementList-labelText]:font-normal',
            '[&_.ais-RefinementList-count]:text-mydra-purple'
          ),
          label: cn(
            'flex items-center gap-1',
            'w-full py-1',
            'cursor-pointer',
            'font-normal'
          ),
          labelText: cn(
            'text-sm leading-6',
            'text-mydra-black',
            'transition-colors',
            'break-words'
          ),
          checkbox: cn('hidden', 'sr-only'),
          count: cn('ml-auto', 'text-sm leading-6', 'text-gray-500'),
          showMore: cn(
            'mt-2 text-sm',
            'text-mydra-purple',
            'hover:underline',
            'cursor-pointer',
            'bg-transparent border-none p-0'
          ),
          disabledShowMore: cn('opacity-50', 'cursor-not-allowed'),
          searchBox: cn(
            'mb-3 flex gap-2',
            '[&_input]:w-full',
            '[&_input]:bg-white',
            '[&_input]:border [&_input]:border-solid [&_input]:border-lines',
            '[&_input]:rounded',
            '[&_input]:px-2 [&_input]:py-1.5',
            '[&_input]:text-xs [&_input]:leading-6 [&_input]:font-medium',
            '[&_input]:text-gray-light',
            '[&_input]:placeholder:text-gray-light',
            '[&_input]:focus:outline-none',
            '[&_input]:focus:ring-1 [&_input]:focus:ring-mydra-purple [&_input]:focus:border-mydra-purple',
            '[&_.ais-SearchBox-submit]:hidden',
            '[&_.ais-SearchBox-reset]:hidden',
            '[&_.ais-SearchBox-loadingIcon]:my-2'
          ),
          noResults: 'text-sm',
          ...refinementListProps.classNames,
        }}
      />
    </SearchRefinementAccordion>
  )
}
